// Collection category filter — pure client-side show/hide over server-rendered
// cards, keyed off a data-pcat computed per-product from its title (this
// catalog has no product_type/tag data to filter on natively).
(function () {
  function init() {
    document.querySelectorAll('[data-coll-filters]').forEach(function (bar) {
      var grid = bar.parentElement.querySelector('[data-coll-grid]');
      if (!grid) return;
      var countEl = bar.parentElement.querySelector('[data-coll-count]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.pcard'));
      var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-coll-filter]'));

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cat = btn.dataset.collFilter;
          buttons.forEach(function (b) { b.classList.toggle('active', b === btn); });
          grid.setAttribute('data-filtering', '');
          var shown = 0;
          cards.forEach(function (card) {
            var match = cat === 'all' || card.dataset.pcat === cat;
            card.hidden = !match;
            if (match) shown++;
          });
          if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
